// extracted by mini-css-extract-plugin
export default {"root":"n8uSzLu_kk","skeletonButton":"gd2Fa3x0Le","moreDetails":"byxISDCRSp"};